import { makeRequest, toCorrectFormDataValue, } from '@/js/libs/api';
import * as Types from './types';
import { encodeBody, fromDateType as fromDate, toDateType as toDate, fromDateTimeType as fromDateTime, toDateTimeUnixType as toDateTime, } from '@/js/libs/api-helpers';
export { fromDate, toDate, fromDateTime, toDateTime };
export const exportInvoiceData = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.invoiceDataDto === undefined) {
        throw new Error('Missing required body: invoiceDataDto');
    }
    const path = '/api/ws-invoice-sync/export-invoice-data';
    const pathInternal = '/api/export-invoice-data';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.invoiceDataDto !== undefined) {
        body = params.invoiceDataDto;
    }
    const headers = {};
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
exportInvoiceData.paramsOrder = [{ type: 'body', paramName: 'invoiceDataDto' }];
export const exportInvoiceProtocol = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.invoiceDataDto === undefined) {
        throw new Error('Missing required body: invoiceDataDto');
    }
    const path = '/api/ws-invoice-sync/export-invoice-protocol';
    const pathInternal = '/api/export-invoice-protocol';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.invoiceDataDto !== undefined) {
        body = params.invoiceDataDto;
    }
    const headers = {};
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
exportInvoiceProtocol.paramsOrder = [{ type: 'body', paramName: 'invoiceDataDto' }];
export const exportInvoicePdf = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.invoicePdfDto === undefined) {
        throw new Error('Missing required body: invoicePdfDto');
    }
    const path = '/api/ws-invoice-sync/export-invoice-pdf';
    const pathInternal = '/api/export-invoice-pdf';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.invoicePdfDto !== undefined) {
        body = params.invoicePdfDto;
    }
    const headers = {};
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
exportInvoicePdf.paramsOrder = [{ type: 'body', paramName: 'invoicePdfDto' }];
export const exportRevenueRecognition = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.revenueRecognitionDto === undefined) {
        throw new Error('Missing required body: revenueRecognitionDto');
    }
    const path = '/api/ws-invoice-sync/export-revenue-recognition';
    const pathInternal = '/api/export-revenue-recognition';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.revenueRecognitionDto !== undefined) {
        body = params.revenueRecognitionDto;
    }
    const headers = {};
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
exportRevenueRecognition.paramsOrder = [{ type: 'body', paramName: 'revenueRecognitionDto' }];
export const exportRevenueRecognitionProtocol = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.revenueRecognitionDto === undefined) {
        throw new Error('Missing required body: revenueRecognitionDto');
    }
    const path = '/api/ws-invoice-sync/export-revenue-recognition-protocol';
    const pathInternal = '/api/export-revenue-recognition-protocol';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.revenueRecognitionDto !== undefined) {
        body = params.revenueRecognitionDto;
    }
    const headers = {};
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
exportRevenueRecognitionProtocol.paramsOrder = [{ type: 'body', paramName: 'revenueRecognitionDto' }];
export const exportPayouts = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.payoutDataDto === undefined) {
        throw new Error('Missing required body: payoutDataDto');
    }
    const path = '/api/ws-invoice-sync/export-payouts';
    const pathInternal = '/api/export-payouts';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.payoutDataDto !== undefined) {
        body = params.payoutDataDto;
    }
    const headers = {};
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
exportPayouts.paramsOrder = [{ type: 'body', paramName: 'payoutDataDto' }];
export const exportPayoutPdf = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.payoutPdfDto === undefined) {
        throw new Error('Missing required body: payoutPdfDto');
    }
    const path = '/api/ws-invoice-sync/export-payout-pdf';
    const pathInternal = '/api/export-payout-pdf';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.payoutPdfDto !== undefined) {
        body = params.payoutPdfDto;
    }
    const headers = {};
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
exportPayoutPdf.paramsOrder = [{ type: 'body', paramName: 'payoutPdfDto' }];
export const exportPayoutProtocol = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.payoutDataDto === undefined) {
        throw new Error('Missing required body: payoutDataDto');
    }
    const path = '/api/ws-invoice-sync/export-payout-protocol';
    const pathInternal = '/api/export-payout-protocol';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.payoutDataDto !== undefined) {
        body = params.payoutDataDto;
    }
    const headers = {};
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
exportPayoutProtocol.paramsOrder = [{ type: 'body', paramName: 'payoutDataDto' }];
export const getPaymentFiles = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.limit === undefined) {
        throw new Error('Missing required parameter: limit');
    }
    if (params.companyConfigDto === undefined) {
        throw new Error('Missing required body: companyConfigDto');
    }
    const path = '/api/ws-invoice-sync/import-payment-files';
    const pathInternal = '/api/import-payment-files';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.limit !== undefined) {
        urlParams.append('limit', params.limit.toString());
    }
    if (params.companyConfigDto !== undefined) {
        body = params.companyConfigDto;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getPaymentFiles.paramsOrder = [{ type: 'body', paramName: 'companyConfigDto' }, { type: 'parameters' }];
export const cleanupPaymentFile = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.fileName === undefined) {
        throw new Error('Missing required parameter: fileName');
    }
    if (params.companyConfigDto === undefined) {
        throw new Error('Missing required body: companyConfigDto');
    }
    const path = '/api/ws-invoice-sync/cleanup-payment-file';
    const pathInternal = '/api/cleanup-payment-file';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.fileName !== undefined) {
        urlParams.append('fileName', params.fileName.toString());
    }
    if (params.companyConfigDto !== undefined) {
        body = params.companyConfigDto;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
cleanupPaymentFile.paramsOrder = [{ type: 'body', paramName: 'companyConfigDto' }, { type: 'parameters' }];
export const recordFileMetaDataBatch = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.body === undefined) {
        throw new Error('Missing required body: body');
    }
    const path = '/api/ws-invoice-sync/file/metadata';
    const pathInternal = '/api/file/metadata';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.body !== undefined) {
        body = params.body;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
recordFileMetaDataBatch.paramsOrder = [{ type: 'body', paramName: 'body' }];
export const getExportDeadlines = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-invoice-sync/export-deadlines';
    const pathInternal = '/api/export-deadlines';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getExportDeadlines.paramsOrder = [];
export const createExportDeadline = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.exportDeadlineForm === undefined) {
        throw new Error('Missing required body: exportDeadlineForm');
    }
    const path = '/api/ws-invoice-sync/export-deadlines';
    const pathInternal = '/api/export-deadlines';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.exportDeadlineForm !== undefined) {
        body = params.exportDeadlineForm;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
createExportDeadline.paramsOrder = [{ type: 'body', paramName: 'exportDeadlineForm' }];
export const getExportDeadlineById = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-invoice-sync/export-deadlines/{id}'.replace('{id}', params.id?.toString());
    const pathInternal = '/api/export-deadlines/{id}'.replace('{id}', params.id?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getExportDeadlineById.paramsOrder = [{ type: 'parameters' }];
export const updateExportDeadline = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    if (params.exportDeadlineForm === undefined) {
        throw new Error('Missing required body: exportDeadlineForm');
    }
    const path = '/api/ws-invoice-sync/export-deadlines/{id}'.replace('{id}', params.id?.toString());
    const pathInternal = '/api/export-deadlines/{id}'.replace('{id}', params.id?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.exportDeadlineForm !== undefined) {
        body = params.exportDeadlineForm;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
updateExportDeadline.paramsOrder = [{ type: 'body', paramName: 'exportDeadlineForm' }, { type: 'parameters' }];
export * from './types';
export * from './constants';
